import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Typography } from '@mui/material';
import { TPreviewOcorrencia } from '../..';
import { TableSimples } from '../../../../../../../components/BasicComponents/DisplayDados/TableSimples';
import { formatarValorMonetario } from '../../../../../../../helpers/masks';
import { DadoValorPrinter } from '../../../../../../../components/BasicComponents/DisplayDados/DadoValorPrinter';
import moment from 'moment';

interface DialogInserirCaixaBancoProps {
  open: boolean;
  preview: TPreviewOcorrencia;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DialogInserirCaixaBanco({
  open,
  preview,
  onClose,
  onConfirm,
}: DialogInserirCaixaBancoProps) {

  const valoresFonteCba = preview.valores_agrupados_por_fonte_cba || [];
  const creditosIdentificar = preview.creditos_a_identificar || [];
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Preview caixas e bancos</DialogTitle>
      <DialogContent>
       
        <Stack spacing={1} direction={'row'} sx={{ mb: 2 }}>
          <DadoValorPrinter
          titulo='Data arquivo'
          valor={moment(preview.data_arquivo).format('DD/MM/YYYY')}
          />
        </Stack>
        {
          valoresFonteCba.length > 0 &&
          <Stack spacing={1} direction={'column'}>
            <Typography variant='body1'><b>Valores a serem inseridos no caixas e bancos:</b></Typography>
            <TableSimples
              headers={[
                { label: "Conta contábil" },
                { label: "Valor", numeric: true }
              ]}
              rows={valoresFonteCba.map(row => ({
                columns: [
                  { value: row.fonte_cba },
                  { value: formatarValorMonetario(row.valor_total), numeric: true }
                ]
              }))}
            />
          </Stack>
        }
        {
          creditosIdentificar.length > 0 &&
          <Stack spacing={1} direction={'column'} sx={{ mt: 2 }}>
            <Typography variant='body1'><b>Créditos a identificar:</b></Typography>
            <TableSimples
              headers={[
                { label: "Título" },
                { label: "Valor", numeric: true }
              ]}
              rows={creditosIdentificar.map(row => ({
                columns: [
                  { value: row.titulo },
                  { value: formatarValorMonetario(row.valor), numeric: true }
                ]
              }))}
            />
          </Stack>
        }
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Cancelar
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          Inserir
        </Button>
      </DialogActions>
    </Dialog>
  );
}
